
import MessageAvatar from "./MessageAvatar";
import ReportContent from "./message/ReportContent";
import DownloadButtons from "./message/DownloadButtons";

type MessageProps = {
  role: "user" | "assistant";
  content: string;
};

const Message = ({ role, content }: MessageProps) => {
  return (
    <div
      className={`py-3 sm:py-4 md:py-6 ${
        role === "assistant"
          ? "bg-gradient-to-r from-gray-900 to-black rounded-2xl"
          : ""
      }`}
    >
      <div className="w-full max-w-3xl mx-auto px-2 sm:px-4">
        <div
          className={`flex gap-2 sm:gap-3 md:gap-6 ${
            role === "user" ? "flex-row-reverse" : ""
          }`}
        >
          <MessageAvatar isAssistant={role === "assistant"} />
          <div
            className={`flex-1 space-y-2 ${
              role === "user" ? "flex justify-end" : ""
            }`}
          >
            <div
              className={`${
                role === "user"
                  ? "bg-gradient-to-r from-blue-600/20 to-blue-500/20 border border-blue-500/10 rounded-2xl px-3 sm:px-4 py-2 sm:py-3 shadow-md max-w-full sm:max-w-[80%] ml-auto"
                  : "max-w-none"
              }`}
            >
              {role === "user" ? (
                <p className="text-sm sm:text-base text-white break-words">
                  {content}
                </p>
              ) : (
                <div className="flex flex-col gap-3 sm:gap-4 px-3 sm:px-4 py-2 sm:py-3 rounded-2xl">
                  <ReportContent content={content} />
                  <div className="mt-2 lg:mt-4">
                    <DownloadButtons content={content} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;
